import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ChatPage from './Chat/ChatPage';
import DocumentsPage from './Documents/DocumentsPage';

export default function ComplianceDashboard() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, px: 3, pt: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="compliance tabs">
          <Tab label="AI Chat" />
          <Tab label="Upload Documents" />
        </Tabs>
      </Box>
      <Box sx={{ flexGrow: 1, overflow: 'auto', px: 3, pb: 3 }}>
        {tabValue === 0 && <ChatPage />}
        {tabValue === 1 && <DocumentsPage />}
      </Box>
    </Box>
  );
}
